/**
 * @note 請一律使用這個 hook 取得畫面的 scrollValue
 *
 * 回傳目前畫面 scrollValue
 * （因為切版的關係，在桌機版是抓 windowScroll、平板和手機版是抓 bodyScroll）
 *
 * @param option: useWindowScroll 或 useScroll 的 option
 * @returns { y: 根據目前的裝置版本回傳 scrollValue }
 */

import type { UseScrollOptions, UseWindowScrollOptions } from '@vueuse/core';
import { useScroll, useWindowScroll } from '@vueuse/core';

export function useScrollValue(
  options?: UseWindowScrollOptions | UseScrollOptions
) {
  if (import.meta.client) {
    const { isDesktop } = useScreen();
    const windowScroll = useWindowScroll(options);
    const bodyScroll = useScroll(document.body, options);

    const y = computed({
      get: (): number => {
        return isDesktop.value ? windowScroll.y.value : bodyScroll.y.value;
      },
      set: (value: number) => {
        if (isDesktop.value) {
          windowScroll.y.value = value;
        } else {
          bodyScroll.y.value = value;
        }
      },
    });

    return { y };
  }
  return { y: ref<number>(0) };
}
